import Facade from "@/Facade"
import {Signals} from "@/Imports";
import BaseManager from "./BaseManager";

export default class ThreePiManager extends BaseManager {

  // How to check
  // https://1x2-nwh-int-staging.com/f1x2games/?supplierID=31

  constructor() {
    super()
  }

  get isReady() {
    return !!window.clientAPI
  }

  // region #Initialization

  init(adapter) {
    super.init(adapter)

    if (Facade.dispatcher)
      Facade.dispatcher.add('relax:modelInitStored', this.onModelInitStored, this)
    else
      Signals && Signals.modelInitStored.add(this.onModelInitStored, this)

    // this.CDN_URL_STAGING = 'https://www.1x2-cloud-1.com/f1x2games/infrastr_generic-framework/clientAPI.game.min.js'
    // this.CDN_URL_PRODUCTION = 'https://www.1x2gamingcdn.com/f1x2games/infrastr_generic-framework/clientAPI.game.min.js'
  }

  onModelInitStored() {
    const {model} = Facade

    if (!model._initRawData || !model._initRawData.tpd) {
      this.onUrlSettings(Facade.urlParams)
      return
    }

    const {_initRawData} = model
    const {tpd} = _initRawData

    if (tpd) {
      const tpd_parsed = JSON.parse(tpd)
      this.accountID = tpd_parsed.accountID
      this.sessionID = tpd_parsed.sessionID
      this.customerID = tpd_parsed.customerID
      this.username = tpd_parsed.username
      this.currencyCode = tpd_parsed.currencyCode ?? "FUN"
    }

    console.log('::: >>> Three PI Manager MODEL INIT STORED')

    this.onUrlSettings(Facade.urlParams)
  }

  onUrlSettings(data) {

    if (data.customer !== 'onextwo') {
      Facade.model.stateMachine && Facade.model.stateMachine.setState('LOADING')
      return
    }

    const playForFun = !!data.playForFun

    if (data.extParams && (!data.ext_params))
      data.ext_params = data.extParams;

    const launchParams = {
      path: data.ext_params['path'],
      lang: data.language,
      clientName: data.ext_params['clientName'],
      lobbyURL: data.ext_params['lobbyurl'],
      operatorID: data.ext_params['operatorid'],
      operatorBrandID: data.ext_params['operatorbrandid'],
      gameID: data.ext_params['gameid'],
      NYX_GCM_ENV: data.ext_params['NYX_GCM_ENV'],
      NYX_GCM_PARAMS: data.ext_params['NYX_GCM_PARAMS'],
      sessionID: data.ext_params['sessionid'],
      jurisdiction: data.ext_params['jurisdiction'],
      regulatoryURL: data.ext_params['regulatoryURL'],
      rcLimit: data.ext_params['reality_check_time'],
      rcElapsed: data.ext_params['rcElapsed'],
      rcExitURL: data.ext_params['rcExitURL'],
      rcHistoryURL: data.ext_params['historyurl'],
      playMode: playForFun ? "demo" : "real",
      hideHome: data.ext_params['hideHome'],
      currencyCode: data.currency,
      environment: process.env.NODE_ENV === 'production' ? "production" : 'staging'
    }

    // const url = Facade.isDebug ?
    //   this.CDN_URL_STAGING :
    //   this.CDN_URL_PRODUCTION

    this.clientInitialized()
      .then(() => {
        console.log('::: Three.PI client API is initialized (launchParams):', launchParams)
        const result = window.clientAPI.init(launchParams)
        return result
      })
      .then(() => {
        const accountParams = {
          accountID: this.accountID,
          sessionID: this.sessionID,
          customerID: this.customerID,
          username: this.username,
          currencyCode: this.currencyCode ?? "FUN",
          operatorID: launchParams.operatorID,
          operatorBrandID: launchParams.operatorBrandID,
          gameID: launchParams.gameID,
          api_version: 3,
        }


        const result = window.clientAPI.configure(accountParams)
        console.log('::: Three.PI client API is configured (accountParams):', accountParams)
        return result
      })
      .then(() => {

        const {clientAPI} = window
        const {adapter} = this


        if (this.isReady) {
          // clientAPI.callbacks['autoplay-enable'].add(() => adapter.startAutoSpins && adapter.startAutoSpins())
          clientAPI.callbacks['autoplay-disable'].add(() => adapter.stopAutospins && adapter.stopAutospins())
          clientAPI.callbacks['game-pause'].add(() => adapter.freeze())
          clientAPI.callbacks['game-resume'].add(() => adapter.unfreeze())
          clientAPI.callbacks['update-balance'].add((value) => adapter.updateBalance(value))
          clientAPI.callbacks['audio-enable'].add(() => adapter.setAudio(true))
          clientAPI.callbacks['audio-disable'].add(() => adapter.setAudio(false))
          clientAPI.callbacks['help-open'].add(() => adapter.showHelp())
          clientAPI.callbacks['help-close'].add(() => adapter.showHelp())
          clientAPI.callbacks['paytable-open'].add(() => adapter.togglePaytable())
          clientAPI.callbacks['paytable-close'].add(() => adapter.togglePaytable())
          clientAPI.callbacks['quickspin-enable'].add(() => adapter.toggleQuickspin && adapter.toggleQuickspin())
          clientAPI.callbacks['quickspin-disable'].add(() => adapter.toggleQuickspin && adapter.toggleQuickspin())

          console.log('::: Threee PI Callbacks are ready >>>')
        }

        if (Facade.model.stateMachine) {
          console.log('>>> ', Facade.model.stateMachine.currentStateName)
          if (Facade.model.stateMachine.currentStateName !== 'LOADING') {
            Facade.model.stateMachine.setState('LOADING')
          }
        }
      })
      .catch(e => {
        console.log('::: Three PI error client initialization', e)
      })
      .finally(() => {
        if (Facade.model.stateMachine) {
          console.log('>>> ', Facade.model.stateMachine.currentStateName)
          if (Facade.model.stateMachine.currentStateName !== 'LOADING') {
            Facade.model.stateMachine.setState('LOADING')
          }
        }
      })

  }

  // endregion

  clientInitialized() {
    return new Promise((resolve, reject) => {
      if (window.clientAPI) {
        resolve()
      } else {
        reject()
      }
    })
  }

  // region #Game events
  loadProgress(progress) {
    if (!this.isReady) return
    const floorProgress = Math.floor(progress)

    window.clientAPI.send('load-progress', floorProgress);
  }

  loadCompleted() {
    if (!this.isReady) return
    window.clientAPI.send('load-end');
  }

  roundStart(value = 0) {
    if (!this.isReady) return
    window.clientAPI.send('play-start');
  }

  roundEnd({balance = 0, totalBet = 0, totalWin = 0}) {
    if (!this.isReady) return
    window.clientAPI.send('play-end');
  }

  featureStart() {
    if (!this.isReady) return
    window.clientAPI.send('feature-start');
  }

  featureFinish() {
    if (!this.isReady) return
    window.clientAPI.send('feature-end');
  }

  autoPlayStarted() {
    if (!this.isReady) return
    window.clientAPI.send('autoplay-start');
  }

  autoplayFinished() {
    if (!this.isReady) return
    window.clientAPI.send('autoplay-end');
  }

  closed() {
    if (!this.isReady) return
    window.clientAPI.send('game-close');
  }

  betUpdate(data) {
    if (!this.isReady) return
    window.clientAPI.send('value-stake', data);
  }

  winUpdate(value) {
    if (!this.isReady) return
    window.clientAPI.send('value-win', value);
  }

  balanceUpdate(value) {
    if (!this.isReady) return

    let stake = Facade.model.currentBet1 + Facade.model.currentBet2
    if (!stake) {
      stake = Facade.model.totalBet
    }

    let balanceObj = {
      balance: value,
      mode: 'place', // or 'place'
      stake,
    }

    if (value) {
      window.clientAPI.send('value-balance', balanceObj);
    } else {
      window.clientAPI.send('no-funds');
    }
  }

  setAudio(value) {
    if (!this.isReady) return
    if (value)
      window.clientAPI.send('audio-enable')
    else
      window.clientAPI.send('audio-disable');
  }

  showHelp() {
    if (!this.isReady) return
    window.clientAPI.send('help-open');
    // clientAPI.send( 'help-close' );
  }

  togglePaytable() {
    if (!this.isReady) return
    window.clientAPI.send('paytable-open');
  }

  errorMessage(errorResponse) {
    if (!this.isReady) return

    if (!window.clientAPI.showInGameErrors) {
      return
    }

    const {errorCode, errorMessage} = errorResponse
    window.clientAPI.send('error', [errorCode, errorMessage.msg])
  }

  // endregion

}
